import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=83b55d14&scoped=true&"
import script from "./CalendarView.vue?vue&type=script&lang=js&"
export * from "./CalendarView.vue?vue&type=script&lang=js&"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=83b55d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b55d14",
  null
  
)

export default component.exports